export const ELLIPSIS = ".";

export const paginate = (current, total, delta) => {
  const left = current - delta;
  const right = current + delta;

  const filter = i =>
    i === 1 ||
    i === total ||
    (i >= left && i <= right) ||
    (current === total - delta - 2 && i === total - 1) ||
    (current === delta + 3 && i === 2) ||
    (current < delta + 3 && i <= 2 * delta + 3) ||
    (current > total - delta - 3 && i > total - 2 * delta - 3);
  const range = [...Array(total).keys()].map(i => i + 1).filter(filter);

  if (range.length > 2 && range[1] - range[0] !== 1) {
    range.splice(1, 0, ELLIPSIS);
  }

  if (
    range.length > 2 &&
    range[range.length - 1] - range[range.length - 2] !== 1
  ) {
    range.splice(range.length - 1, 0, ELLIPSIS);
  }

  return range;
};
